export default "__VITE_ASSET__c18cd2df__"